var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3112 9.11022C25.2286 9.35197 25.9543 10.0638 26.2008 10.9637C26.6526 12.6023 26.6663 16.0003 26.6663 16.0003C26.6663 16.0003 26.6663 19.4118 26.2145 21.037C25.968 21.9368 25.2423 22.6487 24.3249 22.8904C22.6681 23.3337 15.9997 23.3337 15.9997 23.3337C15.9997 23.3337 9.3313 23.3337 7.67447 22.8904C6.75706 22.6487 6.03134 21.9368 5.78487 21.037C5.33301 19.3984 5.33301 16.0003 5.33301 16.0003C5.33301 16.0003 5.33301 12.6023 5.77118 10.9771C6.01765 10.0772 6.74336 9.3654 7.66078 9.12365C9.3176 8.68042 15.986 8.66699 15.986 8.66699C15.986 8.66699 22.6544 8.66699 24.3112 9.11022ZM19.3955 16.0003L13.8636 19.1432V12.8575L19.3955 16.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.c9f1a31768587e69ffc2ad63c9bf83aa.svg";
export { ForwardRef as ReactComponent };